import { sectionRenderer } from '@theme/section-renderer';
import { startViewTransition } from '@theme/utilities';

class CollectionChipFilter extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#handleClick);
    window.addEventListener('popstate', this.#handlePopState);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#handleClick);
    window.removeEventListener('popstate', this.#handlePopState);
  }

  get sectionId() {
    return this.dataset.sectionId;
  }

  #handleClick = async (event) => {
    const chip = event.target instanceof Element ? event.target.closest('[data-chip-url]') : null;

    if (!(chip instanceof HTMLButtonElement)) return;
    if (!this.sectionId || chip.hasAttribute('aria-current')) return;

    event.preventDefault();
    await this.#renderCollection(chip.dataset.chipUrl);
  };

  #handlePopState = async () => {
    if (!this.sectionId) return;

    const url = new URL(window.location.href);
    await startViewTransition(() => sectionRenderer.renderSection(this.sectionId, { cache: false, url }), ['product-grid']);
  };

  async #renderCollection(targetUrl) {
    if (!targetUrl || !this.sectionId) return;

    const nextUrl = new URL(targetUrl, window.location.origin);
    const currentUrl = new URL(window.location.href);
    const currentSort = currentUrl.searchParams.get('sort_by');

    if (currentSort && !nextUrl.searchParams.has('sort_by')) {
      nextUrl.searchParams.set('sort_by', currentSort);
    }

    nextUrl.searchParams.delete('page');

    history.pushState({ path: nextUrl.toString() }, '', nextUrl.toString());
    this.setAttribute('loading', '');

    try {
      await startViewTransition(
        () => sectionRenderer.renderSection(this.sectionId, { cache: false, url: nextUrl }),
        ['product-grid']
      );
    } finally {
      this.removeAttribute('loading');
    }
  }
}

if (!customElements.get('collection-chip-filter')) {
  customElements.define('collection-chip-filter', CollectionChipFilter);
}
